/**
 * Activity Log API Service (Admin only)
 */

import { apiClient } from './client'
import type { ActivityLogListResponse, ActivityLogFilterParams } from '@/types/api'

/**
 * Get paginated list of activity logs (admin only)
 */
export async function getActivityLogs(params?: ActivityLogFilterParams): Promise<ActivityLogListResponse> {
  return apiClient.get<ActivityLogListResponse>('/activity-logs', { params })
}

export const activityService = {
  getActivityLogs,
}
